import React from 'react';
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useCan } from '../../hooks/useCan';
import useLogin from '../../hooks/useLogin';

interface Props {
  slug: string;
  slugSecondary?: string;
  children: JSX.Element;
  isAdmin?: boolean;
}

export function ProtectedRoute({
  slug,
  slugSecondary,
  children,
  isAdmin,
}: Props) {
  const { logout } = useLogin();
  const dispatch = useDispatch();
  const isAllowed = useCan({ view: slug, isAdmin });
  const isAllowedSecondary = useCan({ view: slugSecondary, isAdmin });

  if (!isAllowed) {
    dispatch(logout());
    return <Navigate to="/" />;
  }

  if (!isAllowedSecondary) {
    dispatch(logout());
    return <Navigate to="/" />;
  }

  return children;
}

ProtectedRoute.defaultProps = {
  isAdmin: false,
  slugSecondary: undefined,
};
